<template>
  <div class="home">
    <div class="columns is-mobile">
      <div class="column">
        <h1 class="title is-4">{{ user ? `${user.firstName} ${user.lastName}` : '' }}</h1>
      </div>
      <div class="column has-text-right">
        <button class="button" @click="$router.push({path:'/user-settings'})">
          Settings&nbsp;<i class="fas fa-cog"></i>
        </button>
      </div>
    </div>

    <div class="columns is-multiline">
      <div class="column is-3" v-for="item of items" :key="item.name">
        <button class="button is-large home-button" @click="$router.push({path: item.to})">
          <fa :icon="item.icon" style="font-size: 1.3em;" />&nbsp;{{ item.name}}
        </button>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Home',
  computed: {
    user () { return this.$store.getters.user },
    pages () { return this.$store.getters.pages },
    items () {
      if (!this.user) {
        return []
      }
      let items = []
      let userPrivs = this.user.privileges || []
      for (let page of this.pages) {
        if (page.to === '/home') continue
        if (page.privilege === 'admin') continue
        if (!page.privilege) {
          items.push(page)
        }
        let pagesPrivs = page.privilege ? page.privilege.split(', ') : []
        for (const p of pagesPrivs) {
          if (userPrivs.includes(p)) {
            items.push(page)
            break
          }
        }
      }
      return items
    }
  }
}
</script>

<style>
.home-button {
  width: 100%;
  /* margin: 10px; */
}
</style>
